import { render, staticRenderFns } from "./FeaturedActivities.vue?vue&type=template&id=72cbbcac&scoped=true"
import script from "./FeaturedActivities.vue?vue&type=script&lang=js"
export * from "./FeaturedActivities.vue?vue&type=script&lang=js"
import style0 from "./FeaturedActivities.vue?vue&type=style&index=0&id=72cbbcac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cbbcac",
  null
  
)

export default component.exports